export default __webpack_public_path__ + "04e94c3fca54cab1e01361ef260abd77.png";